<script setup lang="ts"></script>
<template>
  <svg
    viewBox="40 80 816 280"
    xmlns="http://www.w3.org/2000/svg"
    shape-rendering="geometricPrecision"
    class="h-[1.3em] w-auto inline-block align-text-bottom"
  >
    <g fill="none" stroke="currentColor" stroke-width="30" stroke-linecap="round" stroke-linejoin="round">
      <!-- o -->
      <circle cx="120" cy="220" r="60" />
      <!-- p: stem + circle as single path -->
      <path d="M224 340 V 220 A 60 60 0 0 1 344 220 A 60 60 0 0 1 224 220" />
      <!-- e: horizontal line + arc as single path -->
      <path d="M388 220 H 508 A 60 60 0 1 0 496 256" />
      <!-- b: stem + circle as single path -->
      <path d="M552 100 V 220 A 60 60 0 0 1 672 220 A 60 60 0 0 1 552 220" />
      <!-- o with dot -->
      <circle cx="776" cy="220" r="60" />
      <circle cx="818" cy="172" r="16" fill="#00d4ff" stroke="none" />
    </g>
  </svg>
</template>
